import { render, staticRenderFns } from "./SweetAlert.vue?vue&type=template&id=3b0953dc&scoped=true&"
import script from "./SweetAlert.vue?vue&type=script&lang=js&"
export * from "./SweetAlert.vue?vue&type=script&lang=js&"
import style0 from "./SweetAlert.vue?vue&type=style&index=0&id=3b0953dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0953dc",
  null
  
)

component.options.__file = "SweetAlert.vue"
export default component.exports